var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 152,
    viewBox: "0 0 121 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.443 43.6159C109.421 50.3334 98.8582 59.9909 94.5882 66.5734L87.2807 79.3409L87.2782 79.3459L57.3957 131.558C55.1932 134.946 50.7182 136.461 47.3932 134.936L27.4082 125.771L45.3957 87.2384L81.8032 9.24835L109.468 21.9359C117.568 25.6509 119.798 35.3584 114.443 43.6159Z",
    fill: "#00A868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7388 78.8183L72.7687 104.693L57.3938 131.558C55.1913 134.946 50.7163 136.461 47.3913 134.936L27.4062 125.771L66.7388 78.8183Z",
    fill: "#1D232A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6867 124.943L95.9492 15.7334L66.1417 2.06586C58.7642 -1.31664 48.7717 2.79586 45.0692 10.7434L0.896655 106.903C-0.570845 110.096 0.529155 113.443 3.48916 114.801L35.1367 129.313C38.8367 131.013 43.8492 128.936 45.6867 124.943Z",
    fill: "#42EC9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0076 13.4683L110.072 22.2108C102.695 18.8283 92.7026 22.9408 89.0001 30.8884L86.7051 20.1033L91.0076 13.4683Z",
    fill: "#42EC9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4816 121.231L50.2141 104.033C50.8891 102.563 50.2866 100.973 48.7991 100.288L19.329 86.7758C17.4865 85.9308 15.079 86.8083 14.244 88.6258L6.51154 105.823C5.83654 107.293 6.43904 108.883 7.92654 109.568L37.3966 123.083C39.2391 123.926 41.6465 123.048 42.4816 121.231Z",
    fill: "#1D232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1999 47.3108C76.1474 47.3108 76.0949 47.3008 76.0449 47.2758L40.4724 30.9633C40.2849 30.8758 40.2024 30.6533 40.2874 30.4658C40.3724 30.2783 40.5974 30.1958 40.7849 30.2808L76.3574 46.5933C76.5449 46.6808 76.6274 46.9033 76.5424 47.0908C76.4774 47.2283 76.3424 47.3108 76.1999 47.3108Z",
    fill: "#1D232A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2475 123.213L7.50002 109.113C6.11002 108.476 5.50002 106.833 6.13752 105.446L14.35 87.5358C14.9875 86.1458 16.63 85.5358 18.0175 86.1733L48.765 100.273C50.155 100.911 50.765 102.553 50.1275 103.941L41.915 121.851C41.28 123.241 39.6375 123.851 38.2475 123.213Z",
    fill: "#1D232A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.12 97.3233L19.375 83.2233C17.985 82.5858 17.375 80.9433 18.0125 79.5558L37.5625 36.9259C38.2 35.5359 39.8425 34.9259 41.23 35.5634L71.9776 49.6634C73.3676 50.3009 73.9776 51.9434 73.3401 53.3309L53.7901 95.9608C53.1525 97.3508 51.51 97.9608 50.12 97.3233Z",
    fill: "#1D232A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2267 38.3083L87.1017 26.7084C88.4367 24.0709 87.0817 20.9659 83.9742 19.5384L58.5242 7.86836C54.9767 6.24086 50.5992 7.43586 49.0742 10.4459",
    fill: "#42EC9A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2264 38.6833C81.1689 38.6833 81.1114 38.6708 81.0564 38.6433C80.8714 38.5508 80.7964 38.3233 80.8914 38.1383L86.7664 26.5383C87.3114 25.4633 87.3889 24.2908 86.9889 23.1483C86.5014 21.7558 85.3739 20.5933 83.8164 19.8783L58.3665 8.20835C55.019 6.67335 50.834 7.79835 49.4065 10.6133C49.314 10.7983 49.0865 10.8708 48.9015 10.7783C48.7165 10.6858 48.6415 10.4583 48.7365 10.2733C50.364 7.05835 54.9165 5.80085 58.6765 7.52585L84.1289 19.1983C85.8764 19.9983 87.1439 21.3158 87.6989 22.9033C88.1589 24.2233 88.0664 25.6333 87.4364 26.8783L81.5614 38.4783C81.4939 38.6083 81.3614 38.6833 81.2264 38.6833Z",
    fill: "#00A868"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5443 102.993L40.1468 95.1384L39.4643 94.8259L35.8618 102.681L24.6168 97.5259L28.2193 89.6684L27.5393 89.3559L23.9368 97.2134L11.5768 91.5459L11.2643 92.2259L23.6243 97.8934L20.0143 105.768L7.6543 100.101L7.3418 100.783L19.6993 106.451L15.8643 114.816L16.5443 115.128L20.3793 106.763L31.6268 111.918L27.7893 120.286L28.4693 120.598L36.2318 103.676L48.6393 109.366L48.9518 108.683L36.5443 102.993ZM31.9393 111.238L20.6943 106.081L24.3043 98.2059L35.5493 103.363L31.9393 111.238Z",
    fill: "#42EC9A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9963 102.926C73.8163 102.926 73.6563 102.796 73.6263 102.611L69.6512 78.4283C69.6187 78.2233 69.7562 78.0308 69.9612 77.9983C70.1637 77.9633 70.3588 78.1033 70.3913 78.3083L74.3663 102.491C74.3988 102.696 74.2613 102.888 74.0563 102.921C74.0388 102.923 74.0163 102.926 73.9963 102.926Z",
    fill: "#1D232A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1775_3468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.75 146.125C105.214 146.125 117.75 133.589 117.75 118.125C117.75 102.661 105.214 90.125 89.75 90.125C74.286 90.125 61.75 102.661 61.75 118.125C61.75 133.589 74.286 146.125 89.75 146.125Z",
    fill: "#E8E9EA"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1014 132.253C84.389 132.253 83.6719 131.994 83.1076 131.472L73.7782 122.851C72.5862 121.748 72.5133 119.891 73.6136 118.699C74.7163 117.507 76.5738 117.434 77.7658 118.534L84.9368 125.162L101.567 107.166C102.669 105.974 104.527 105.901 105.719 107.002C106.911 108.104 106.984 109.962 105.883 111.154L87.2598 131.308C86.6814 131.936 85.8938 132.253 85.1014 132.253Z",
    fill: "#00A868"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1775_3468",
    x: 58.75,
    y: 89.125,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0 0.333333 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1775_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1775_3468",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineSuccess);
export default __webpack_public_path__ + "static/media/machine-success.826091b605ba1490803b3f02f8b1449d.svg";
export { ForwardRef as ReactComponent };